import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { leaderboardActions } from "../../../../redux/actions";
import { leaderboardConstants } from "../../../../constants";
import {
  loadingIndicator,
  dataEndMessage,
} from "../../../../shared/utilitiies";

import LeaderboardRankCard from "../../../../shared/components/LeaderboardRankCard/LeaderboardRankCard";

const LeaderboardDetail = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [topRanks, setTopRanks] = useState([]);
  const [otherRanks, setOtherRanks] = useState([]);

  const ranking = useSelector((state) => state?.leaderboardReducer?.rankings);

  useEffect(() => {
    setTopRanks(ranking?.leaderboard?.filter((comp) => comp.rank <= 3));
    setOtherRanks(ranking?.leaderboard?.filter((comp) => comp.rank > 3));
    // eslint-disable-next-line
  }, [ranking]);

  //-------Get More Centers List on Scroll
  const getMoreRankingDetails = () => {
    const updatedGridState = {
      ...props.gridState,
      length: (props.gridState.length += 15),
    };
    props.setGridState(updatedGridState);
  };

  const setMedalType = (index) => {
    if (index == 1) {
      return leaderboardConstants.GOLD_MEDAL;
    }
    if (index == 2) {
      return leaderboardConstants.SILVER_MEDAL;
    }
    if (index == 3) {
      return leaderboardConstants.BRONZE_MEDAL;
    }
  };

  const isMobile = useSelector((state) => {
    return state.systemReducer.isMobile;
  });

  return (
    <div className={`${isMobile ? "px-3" : "leaderboard-container"} pt-2`}>
      {topRanks?.length > 0 && (
        <div className="">
          {topRanks?.map((userData, index) => (
            <LeaderboardRankCard
              key={index}
              userData={userData}
              medal={setMedalType(userData?.rank)}
            />
          ))}
        </div>
      )}

      <div className="d-flex justify-content-center">
        <InfiniteScroll
          dataLength={otherRanks?.length ?? 0}
          next={getMoreRankingDetails}
          hasMore={
            otherRanks?.length % 4 === 0 && otherRanks?.length !== 0
              ? true
              : false
          }
          loader={loadingIndicator(t)}
          endMessage={dataEndMessage(t, otherRanks)}
          style={{ overflow: "hidden" }}
          scrollableTarget={"main-container"}
        >
          {otherRanks?.map((userData, index) => (
            <LeaderboardRankCard
              key={index}
              isLowerRanks={true}
              userData={userData}
            />
          ))}
        </InfiniteScroll>
      </div>
    </div>
  );
};

export default LeaderboardDetail;
